<template lang="pug">
section.subpage.profile.pb-5(ref="subpage")
  h2.title
    span {{ page.title }}
  b-table(ref="table",responsive,no-local-sorting,:items="data",:fields="fields")
    template(v-slot:cell(count)="row")
      b-row
        b-col
          span.count {{ row.item.count }}
        b-col(v-if="row.item.name === '候補者'")
          b-button.p-0(variant="link",size="sm",@click="onDownloadPeoples()") CSVダウンロード
</template>

<script>
import { getData } from '../utils/api'

const page = {
  id: 'usage',
  title: 'ご利用情報'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      page: page,
      currentUser: null,
      data: [{
        name: '候補者',
        count: null
      }, {
        name: 'ポジション',
        count: null
      }, {
        name: '採用ルート',
        count: null
      }, {
        name: 'メンバー',
        count: null
      }, {
        name: 'テンプレート',
        count: null
      }],
      fields: [{
        key: 'name',
        label: 'データ種別'
      }, {
        key: 'feature',
        label: ''
      }, {
        key: 'count',
        label: '登録件数'
      }]
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      this.mask = true

      let message = ''

      this.nums = []

      try {
        this.data[0].count = Number(await getData(`/peoples/count`))
        this.data[1].count = Number(await getData(`/jobs/count`))
        this.data[2].count = Number(await getData(`/routes/count`))
        this.data[3].count = Number(await getData(`/users/count`))
        this.data[4].count = Number(await getData(`/boilerplates/count`))
      } catch (e) {
        message = '件数の取得に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }

      this.$parent.$refs.header.checkCondition()

      this.$forceUpdate()
    },
    onDownloadPeoples () {
      this.msgBoxConfirm('候補者情報をダウンロードしますか？', this.doDownloadPeoples)
    },
    async doDownloadPeoples () {
      let message = ''
      let blob = null

      this.mask = true

      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])

      try {
        await getData(`/peoples/download`).then((data) => {
          if (data) {
            blob = new Blob([bom, data], { type: 'text/csv' })
          } else {
            message = 'データのダウンロードに失敗しました'
          }
        }).catch((err) => {
          console.log(err)
          message = 'データのダウンロードに失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } catch (e) {
        message = 'データのダウンロードに失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'peoples.csv'
        link.click()
      }
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
